import styled from 'styled-components';
import { Button } from 'reactstrap';
import { color } from '~/assets/styles/colors';

export const TextError = styled.div`
	color: #c53030;
`;

export const TrStyled = styled.tr`
	background: ${color.primary};
	color: ${color.softBlack} !important;

	th {
		padding: 10px !important;
		text-transform: uppercase !important;
		font-weight: bold !important;
		&::after {
			width: 0 !important;
		}
	}
`;

export const ButtonStyled = styled(Button)`
	background-color: ${({ disabled }) =>
		!disabled ? '#dbdbdb' : color.primary} !important;
	border-radius: 0 !important;
	border: 0 !important;
	border-radius: 10px !important;
	color: ${({ disabled }) =>
		!disabled ? color.gray : color.black} !important;
	opacity: 1 !important;

	&:hover {
		background-color: ${color.primary} !important;
		opacity: 0.6 !important;
	}
`;

export const ButtonStyledSimular = styled(Button)`
	background-color: ${color.primary} !important;
	border: 0 !important;
	width: 50%;
	border-radius: 10px !important;
	color: ${color.black} !important;
	opacity: 1 !important;

	&:hover {
		background-color: ${color.greenDark} !important;
	}

	&:focus {
		background-color: ${color.primary} !important;
	}
`;

export const ButtonStyledGerarLink = styled(Button)`
	background-color: ${color.secondary} !important;
	border: 0 !important;
	width: 50%;
	border-radius: 10px !important;
	color: ${color.black} !important;
	opacity: 1 !important;

	&:hover {
		 background-color: ${color.blueDark} !important;
	}

	&:focus {
		background-color: ${color.secondary} !important;
	}
`;
